<template>
  <div>
    <!-- <div class="d-flex mb-5">
      <div class="col-5 pl-0">
        <v-text-field dense outlined v-model="orders.search" append-icon="mdi-magnify" :label="$t('searchLabel')"
          single-line hide-details>
        </v-text-field>
      </div>
    </div> -->
    <div class="text-right">
        <v-btn class="white--text ma-2"
               color="primary"
               :loading="syncLoading"
               @click="syncOrders">
          <v-icon left class="mr-4"> mdi-sync </v-icon> {{ $t("syncLabel") }}
        </v-btn>
        <v-btn @click="showFilters = !showFilters" color="primary">
          <template v-if="showFilters">
            <v-icon left>mdi-eye-off</v-icon>
            {{ $t('hideFiltersLabel') }}
          </template>
          <template v-else>
            <v-icon left>mdi-eye</v-icon>
            {{ $t('showFiltersLabel') }}
          </template>
        </v-btn>
    </div>
    <div class="mb-4" v-if="showFilters">
      <div class="body-1 mb-2">{{ $t("filterByLabel") }}</div>
      <div class="d-flex">
        <v-col cols="4" class="pa-0">
          <v-card-text class="pa-0">
            <div class="price-range d-flex align-center mr-4">
              <v-text-field :label="$t('startingPriceLabel')" v-model="startPrice" outlined dense class="mt-0 pt-0 mr-2"
                hide-details type="number" style="width: 120px" suffix="€">
              </v-text-field>
              <div class="mr-2">-</div>
              <v-text-field :label="$t('endingPriceLabel')" v-model="endPrice" outlined dense class="mt-0 pt-0"
                hide-details type="number" style="width: 120px" suffix="€">
              </v-text-field>
            </div>
          </v-card-text>
        </v-col>
        <v-col cols="2" class="pa-0">
          <v-text-field hide-details class="mr-4" dense outlined clearable :label="$t('bestellnummerLabel')" v-model="purchNoFilter">
          </v-text-field>
        </v-col>
        <v-col cols="2" class="pa-0">
          <v-menu v-model="menu2" :close-on-content-click="false" :nudge-right="40" transition="scale-transition"
            offset-y min-width="290px">
            <template v-slot:activator="{ on, attrs }">
              <v-text-field class="mr-4" hide-details outlined clearable @click:clear="clearDate" dense
                v-model="dateRangeText" :label="$t('dateRangeLabel')" readonly v-bind="attrs" v-on="on">
              </v-text-field>
            </template>
            <v-date-picker :locale="$i18n.locale" color="primary" v-model="dates" range></v-date-picker>
          </v-menu>
        </v-col>
        <v-col cols="2" class="pa-0" v-if="canFilterByCompany">
          <v-autocomplete hide-details class="mr-4" dense outlined v-model="selectedCompany" :items="companies"
            item-text="companyName" item-value="companyId" :label="$t('companyLabel')" clearable>
          </v-autocomplete>
        </v-col>
        <v-col cols="2" class="pa-0 d-flex ml-auto">
          <div class="filter" style="width:100%">
            <v-btn @click="page = 1; filter(); filterEnabled();" class="" width="100%" color="primary" height="100%">
              <v-icon left>mdi-filter</v-icon>
              {{$t('filterLabel')}}
            </v-btn>
          </div>
          <div class="reset pl-4" v-if="filtered">
            <v-btn @click="page = 1; filterDisabled()" class="" width="100%" color="red" height="100%">
              <v-icon color="white">mdi-restore</v-icon>
            </v-btn>
          </div>
        </v-col>
      </div>
    </div>
    <v-data-table :footer-props="orders.footerProps" :page.sync="page" :options.sync="options" :server-items-length="1" :headers="orders.headers"
      :items="orders.values" :loading="loading" :loading-text="$t('tableLoadingLabel')">
      <template v-if="canEdit" #item.actions="{ item }">
        <v-btn v-if="!isSPA" class="ml-4 primary--text" small outlined :to="{ name: 'OrderDetails', params: { orderId: item.id } }">
          {{ $t("showDetailsLabel") }}</v-btn>
        <v-btn v-else class="ml-4 primary--text" small outlined :to="{ name: 'SpaUserOrderDetails', params: { orderId: item.id, companyId: spaCompanyId, userId: spaUserId } }">
          {{ $t("showDetailsLabel") }}</v-btn>
      </template>
      <template v-slot:item.orderDate="{ item }">
        <span>{{new Date(item.orderDate).toLocaleDateString()}}</span>
      </template>
      <template v-slot:item.canceled="{ item }">
        <v-chip
            :color="getColor(item.canceled)"
            dark
            small
        >
          {{ item.canceled ? $t('canceledLabel') : $t('activeOrderLabel') }}
        </v-chip>
      </template>
      <template v-slot:no-data>
        {{$t('noDataAvailable')}}
      </template>
      <template v-slot:no-results>
        {{$t('noDataAvailable')}}
      </template>
    </v-data-table>
    <v-pagination v-model="page" :length="pageCount" @input="filter()"></v-pagination>
  </div>
</template>
<script>
  import UserTypes from "../auth/userTypes";
  import moment from "moment";
  import {
    mapActions
  } from "vuex";
  import StatusTypes from "../configurator/StatusTypes";
  export default {
    name: "OrdersTable",
    data() {
      return {
        options: {},
        spaCompanyId: '',
        spaUserId: '',
        isSPA:false,
        showFilters: false,
        filtered: false,
        page: 1,
        pageCount: 1,
        amount: 5,
        itemsPerPage: 1,
        sortBy:'orderNo',
        sortDesc: true,
        selectedCompany: "",
        startPrice: "",
        endPrice: "",
        dates: ["", ""],
        purchNoFilter: '',
        menu2: false,
        companies: [],
        loading: true,
        syncLoading: false,
        snackbar: {
          show: false,
          message: "",
        },
        orders: {
          search: "",
          headers: [{
              text: this.$t('ordersNoLabel'),
              value: "orderNo",
            },
            {
              text: this.$t('bestellnummerLabel'),
              value: "purchValue",
            },
            {
              text: this.$t('ordersCustNoLabel'),
              value: "customerNo",
            },
            {
              text: this.$t('ordersNetValueLabel'),
              value: "netValue",
            },
            {
              text: this.$t('ordersCurrencyLabel'),
              value: "currency",
            },
            {
              text: this.$t('ordersDateLabel'),
              value: "orderDate",
            },
            {
              text: this.$t('ordersCompanyLabel'),
              value: "companyName",
            },
            {
              text: this.$t('statusLabel'),
              value: "canceled",
            },
            {
              text: "",
              sortable: false,
              value: "actions",
              align: "end",
            },
          ],
          values: [],
          footerProps:{
            'items-per-page-options' : [5, 10, 15, 20, -1],
            'disable-pagination': true,
            'next-icon': null,
            'prev-icon': null,
            'page-text' : '',
            'items-per-page-all-text': this.$t('allLabel'),
            'items-per-page-text': this.$t('rowsPerPageLabel')
          }
        },
      };
    },
    props: {
      companyId: Number,
      userId: Number,
      canEdit: Boolean,
      getByUser: Boolean,
      getByCompany: Boolean,
      canFilterByCompany: Boolean,
    },
    watch: {
      options: {
        handler(){
          const options = this.options;
          this.amount = options.itemsPerPage
          if(options.sortBy.length > 0 && options.sortDesc.length > 0) {
            this.sortBy = options.sortBy[0];
            this.sortDesc = options.sortDesc[0];
          }
          else {
            if(this.sortBy !== 'orderNo' && this.sortDesc !== false) {
              this.sortBy = 'orderNo';
              this.sortDesc = false;
            }
          }
          this.filter();
          // const sortBy = options.sortBy.length > 0 ? options.sortBy[0] : 'orderNo';
          // const sortDesc = options.sortDesc.length > 0 ? options.sortDesc[0] : false;
          // this.sortBy = sortBy;
          // this.sortDesc = sortDesc;
          // this.filter();
        },
        deep: true
      }
    },
    methods: {
      ...mapActions("configuratorModule", ["setProductId"]),
      // getOrders() {
      //     this.axios.get('api/order/getOrders').then(response => {
      //         this.orders.values = response.data;
      //         this.loading = false
      //         this.getCompanies()
      //     }).catch(error => {
      //         console.log(error)
      //         this.loading = false
      //     });
      // },
      // getOrdersByCompany() {
      //     this.axios.get('api/order/getOrdersByCompany', {
      //         params: {
      //             companyId: this.$props.companyId
      //         }
      //     }).then(response => {
      //         this.orders.values = response.data;
      //         this.loading = false
      //         this.getCompanies()
      //     }).catch(error => {
      //         console.log(error)
      //         this.loading = false
      //     });
      // },
      // getOrdersByUser() {
      //     this.axios.get('api/order/getOrdersByUser', {
      //         params: {
      //             userId: this.$props.userId
      //         }
      //     }).then(response => {
      //         this.orders.values = response.data;
      //         this.loading = false
      //         this.getCompanies()
      //     }).catch(error => {
      //         console.log(error)
      //         this.loading = false
      //     });
      // },
      clearDate() {
        this.dates[0] = "";
        this.dates[1] = "";
      },
      filterEnabled() {
        this.filtered = true
      },
      filterDisabled() {
        this.filtered = false
        this.purchNoFilter = ''
        this.selectedCompany = ''
        this.startPrice = ''
        this.endPrice = ''
        this.clearDate()
        this.filter()
      },
      async filter() {
        this.loading = true;
        const dataParams = {
          getByCompany: this.selectedCompany ? true : false,
          getByUser: false,
          selectedCompanyId: this.selectedCompany ? this.selectedCompany : '',
          userId: '',
          purchNo: this.purchNoFilter,
          startPrice: this.startPrice,
          endPrice: this.endPrice,
          startDate: this.dates[0],
          endDate: this.dates[1],
          amount: this.amount,
          page: this.page,
          sortBy: this.sortBy,
          sortDesc: this.sortDesc
        };
        // const SalesPartnershipAdmin = {
        //   isWertheimSales: false,
        //   isSalesPartnershipAdmin: true,
        //   isSalesPartnershipSales: false,
        //   getByCompany: true,
        //   getByUser: false,
        //   companyId: this.companyId,
        //   userId: '',
        //   startPrice: this.startPrice,
        //   endPrice: this.endPrice,
        //   startDate: this.dates[0],
        //   endDate: this.dates[1],
        //   amount: this.amount,
        //   page: this.page,
        // };
        // const SalesPartnershipSales = {
        //   isWertheimSales: false,
        //   isSalesPartnershipAdmin: false,
        //   isSalesPartnershipSales: true,
        //   getByCompany: false,
        //   getByUser: true,
        //   companyId: '',
        //   userId: this.userId,
        //   startPrice: this.startPrice,
        //   endPrice: this.endPrice,
        //   startDate: this.dates[0],
        //   endDate: this.dates[1],
        //   amount: this.amount,
        //   page: this.page,
        // };
        // const OtherUser = {
        //   isWertheimSales: false,
        //   isSalesPartnershipAdmin: false,
        //   isSalesPartnershipSales: false,
        //   getByCompany: this.selectedCompany ? true : false,
        //   getByUser: false,
        //   companyId: this.selectedCompany ? this.selectedCompany : '',
        //   userId: '',
        //   startPrice: this.startPrice,
        //   endPrice: this.endPrice,
        //   startDate: this.dates[0],
        //   endDate: this.dates[1],
        //   amount: this.amount,
        //   page: this.page,
        // };

        // var dataParams;

        // if (this.$store.state.user.userType == UserTypes.WertheimSales) {
        //   dataParams = WertheimSales
        // } else if (this.$store.state.user.userType == UserTypes.SalesPartnershipAdmin) {
        //   dataParams = SalesPartnershipAdmin
        // } else if (this.$store.state.user.userType == UserTypes.SalesPartnershipSales) {
        //   dataParams = SalesPartnershipSales
        // } else {
        //   dataParams = OtherUser
        // }
        
        this.axios
          .get("/api/order/filterOrders/", {
            params: dataParams
          })
          .then((response) => {
            this.pageCount = response.data.pages;
            this.orders.values = response.data.filteredOrders;
            this.loading = false;
            if (!this.companies.length) {
              this.companies = response.data.companies;
            }
            // if(!this.companies){
            // }

            // this.getCompanies()
          })
          .catch((error) => {
            const snackbar = {
              show: true,
              message: error.message,
            };
            this.$EventBus.$emit("snackbar", snackbar);
            this.loading = false;
          });
      },
      customSort: function(items, index, isDesc){
        debugger;
        const sortBy = index.length > 0 ? index[0] : '';
        const sortDesc = isDesc.length > 0 ? isDesc[0] : null;

        this.sortBy = sortBy;
        this. sortDesc = sortDesc;
        
        // this.filter();

        return this.orders.values;
      },
      // async getCompanies() {
      //   this.axios
      //     .get("/api/company/getAll/")
      //     .then((response) => {
      //       this.companies = response.data;
      //     });
      // },
      // async fetchOrders() {
      //     await this.axios.get('/api/order/filterOrders/', {
      //             params: {
      //                 amount: this.amount
      //             }
      //         })
      //         .then(response => {
      //             this.tutors = response.data.tutors
      //             this.totalNumberOfTutors = response.data.tutorTotal
      //             this.countries = response.data.countries
      //             this.levels = response.data.educationLevels
      //             this.loading = false
      //         })
      //         .catch(error => {
      //             const snackbar = {
      //                 show: true,
      //                 message: error.message
      //             }
      //             this.$EventBus.$emit('snackbar', snackbar)
      //         })
      // },
      checkSpa(){
        // let props = this.$router.resolve({ name: 'SalePartnerships'}).route.name
        // console.log(props);
        if(this.$route.fullPath.includes('sale-partnerships')){
          this.isSPA = true
        }
        else{
          this.isSPA = false
        }
        this.spaCompanyId = this.$route.params.companyId
        this.spaUserId = this.$route.params.userId
      },
      syncOrders(){
        this.syncLoading = true
        this.axios.get('api/sap/syncOrders')
            .then(res => {
              this.filter()
              console.log(res)
            })
            .catch(e => {
              this.snackbar.message = this.$t('syncError');
              this.snackbar.show = true;
              this.$EventBus.$emit("snackbar", this.snackbar);
              console.log(e)
            })
            .finally(f => this.syncLoading = false)
      },
      getColor(canceled){
        return canceled ? 'red' : 'green'
      }
    },
    mounted() {
      // this.filter();
      this.checkSpa();
      // this.getCompanies();
      // if (this.$props.getByUser) {
      //     this.getOrdersByUser();
      // } else if (this.$props.getByCompany) {
      //     this.getOrdersByCompany();
      // } else {
      //     this.getOrders();
      // }
    },
    computed: {
      dateRangeText() {
        return this.dates.join(" ~ ");
      },
    },
  };
</script>
<style scoped>
</style>